module.exports = __webpack_public_path__ + "static/media/dummies_slide_1.a84d0a23.png";